export enum StakingStrategies {
    KellyCriterion = 'KELLY_CRITERION',
    FixedStake = 'FIXED_STAKE',
    FixedPercentage = 'FIXED_PERCENTAGE',
    MartingaleSystem = 'MARTINGALE_SYSTEM',
    AntiMartingaleSystem = 'ANTI_MARTINGALE_SYSTEM',
    FibonacciSequence = 'FIBONACCI_SEQUENCE',
    DAlembertSystem = 'D_ALEMBERT_SYSTEM',
    ProportionalBetting = 'PROPORTIONAL_BETTING',
    UnitBetting = 'UNIT_BETTING',
    ContraDAlembertSystem = 'CONTRA_D_ALEMBERT_SYSTEM',
    MillerStrategy = 'MILLER_STRATEGY',
}